import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";
import { GoldPerksSection } from "@src/appV2/redesign/Tiers/PerksSection/GoldPerksSection";
import { LimitedPerksSection } from "@src/appV2/redesign/Tiers/PerksSection/LimitedPerksSection";
import { SilverPerksSection } from "@src/appV2/redesign/Tiers/PerksSection/SilverPerksSection";
import { TIERS_PERKS_SECTION_ID } from "@src/appV2/redesign/Tiers/utils/constants";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

interface PerksSectionProps {
  workerTier: TierType;
}

export function PerksSection(props: PerksSectionProps) {
  const { workerTier } = props;
  const perks = [
    <GoldPerksSection key="gold-perks" workerTier={workerTier} />,
    <SilverPerksSection key="silver-perks" workerTier={workerTier} />,
    <LimitedPerksSection key="limited-perks" workerTier={workerTier} />,
  ];
  const history = useHistory();
  const location = useLocation();

  // Scroll to this section upon coming here with the appropriate hash
  useEffect(() => {
    const { hash, pathname, search } = location;
    const scrollToSection = hash.replace("#", "");

    if (scrollToSection === TIERS_PERKS_SECTION_ID) {
      const element = document.querySelector<HTMLElement>(hash);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });

        // Clean up the hash from URL
        history.replace({
          pathname,
          search,
          hash: "",
        });
      }
    }
  }, [history, location]);

  return (
    <Box id={TIERS_PERKS_SECTION_ID}>
      <Stack direction="column" gap={6}>
        <Text semibold variant="h4">
          Membership Perks
        </Text>
        {perks}
      </Stack>
    </Box>
  );
}
